var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.studentSieId)?_c('div',[_c('PageHeader',{attrs:{"has-return":"","page":{
      icon: 'fas fa-user-edit',
      title: 'Historial de Terapias',
      routes: ['Inicio', 'Historial de Terapias'],
    }}}),_c('StudentServicesHistory',{attrs:{"student-sie-id":_vm.studentSieId}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }